import { useMemo } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { getBlogPost } from "@/lib/blogPosts";

const CANONICAL_ORIGIN = "https://www.rentsense.nl";

/**
 * Manages canonical URL, hreflang, and language settings for SEO.
 * Always uses the production domain for canonical URLs regardless of environment.
 * Unknown /blog/:slug routes get no canonical (they are not real pages).
 */
export default function Canonical() {
  const { pathname } = useLocation();

  const canonicalHref = useMemo(() => {
    const cleanPath = pathname === "/" ? "/" : pathname.replace(/\/$/, "");
    const blogMatch = cleanPath.match(/^\/blog\/(.+)$/);
    if (blogMatch && !getBlogPost(blogMatch[1])) return null;
    return `${CANONICAL_ORIGIN}${cleanPath}`;
  }, [pathname]);

  return (
    <Helmet>
      <html lang="en" />
      <meta
        name="robots"
        content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
      />
      {canonicalHref && <link rel="canonical" href={canonicalHref} />}
      {canonicalHref && <link rel="alternate" hrefLang="en" href={canonicalHref} />}
      {canonicalHref && <link rel="alternate" hrefLang="x-default" href={canonicalHref} />}
      <meta property="og:locale" content="en_US" />
      <meta property="og:site_name" content="RentSense NL" />
      <meta property="og:image" content="https://www.rentsense.nl/og-image.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content="https://www.rentsense.nl/og-image.png" />
    </Helmet>
  );
}
